import { useQuery } from '@tanstack/react-query';

import { farmsApi } from '../../apis/farms.api';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseFarms {}

export function useFarms() {
  const query = useQuery({
    queryKey: ['farms'],
    queryFn: farmsApi.getAll,
  });

  return query;
}

export default useFarms;
